<template>
  <div>
    <v-expansion-panel popout class="futuristic-expansion">
      <v-expansion-panel-content>
        <template slot="header">
          <h4 class="earth-color">GLOBAL SEARCH</h4>
        </template>
        <template slot="actions">
          <v-icon color="#587e27">$vuetify.icons.expand</v-icon>
        </template>
        <search-tabs></search-tabs>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <br />

    <v-expansion-panel popout class="futuristic-expansion">
      <v-expansion-panel-content>
        <template slot="header">
          <h4 class="earth-color">SEARCH PARAMETERS</h4>
        </template>
        <v-card flat class="futuristic-inner-card">
          <v-layout row wrap>
            <!-- Added Destination filter -->
            <v-flex lg2 md3 sm4 xs12>
              <v-container fluid>
                <v-autocomplete
                  label="Destination"
                  v-model="destination_filter"
                  :items="allDestinations"
                  :rules="[(v) => !!v || 'Item is required']"
                  required
                  item-text="destination_name"
                  item-value="destination_public_id"
                  class="futuristic-input"
                ></v-autocomplete>
              </v-container>
            </v-flex>
            
            <!-- Added Country filter -->
            <v-flex lg2 md3 sm4 xs12>
              <v-container fluid>
                <v-autocomplete
                  label="Country"
                  v-model="country_filter"
                  :items="allCountries"
                  :rules="[(v) => !!v || 'Item is required']"
                  required
                  item-text="name"
                  item-value="code"
                  :loading="$loadingTrue"
                  class="futuristic-input"
                ></v-autocomplete>
              </v-container>
            </v-flex>
            
            <v-flex lg2 md3 sm4 xs12>
              <v-container fluid>
                <v-autocomplete
                  label="Status"
                  v-model="booking_status_filter"
                  :items="$findBookingStatus()"
                  :rules="[(v) => !!v || 'Item is required']"
                  required
                  class="futuristic-input"
                ></v-autocomplete>
              </v-container>
            </v-flex>
            <v-flex lg2 md3 sm4 xs12>
              <v-container fluid>
                <v-autocomplete
                  label="Booking Type"
                  v-model="booking_types_filter"
                  :items="$findBookingTypes()"
                  :rules="[(v) => !!v || 'Item is required']"
                  required
                  class="futuristic-input"
                ></v-autocomplete>
              </v-container>
            </v-flex>
            <v-flex lg2 md3 sm4 xs12>
              <v-container fluid>
                <v-autocomplete
                  label="Guest Numbers"
                  v-model="booking_guest_number_filter"
                  :items="$findGuestNumbers()"
                  :rules="[(v) => !!v || 'Item is required']"
                  required
                  class="futuristic-input"
                ></v-autocomplete>
              </v-container>
            </v-flex>
            <v-flex lg2 md3 sm4 xs12>
              <v-container fluid>
                <v-select
                  label="Has Guest Type(s)"
                  v-model="booking_guest_type_filter"
                  :items="allConservationFees"
                  :rules="[(v) => !!v || 'Item is required']"
                  required
                  multiple
                  item-text="payment_person"
                  item-value="payment_person"
                  class="futuristic-input"
                ></v-select>
              </v-container>
            </v-flex>
            <v-flex lg2 md3 sm4 xs12>
              <v-container>
                <v-autocomplete
                  label="Booking Source"
                  v-model="booking_source_filter"
                  :items="$findBookingSource()"
                  :rules="[(v) => !!v || 'Item is required']"
                  required
                  class="futuristic-input"
                ></v-autocomplete>
              </v-container>
            </v-flex>
            <v-flex lg2 md2 sm4 xs12>
              <v-container fluid>
                <v-select
                  label="Has Accommodation(s)"
                  v-model="booking_accommodation_filter"
                  :items="allFacilities"
                  :rules="[(v) => !!v || 'Item is required']"
                  required
                  multiple
                  item-text="name"
                  item-value="public_id"
                  class="futuristic-input"
                ></v-select>
              </v-container>
            </v-flex>
            <v-flex lg2 md2 sm4 xs12>
              <v-container fluid>
                <v-select
                  label="Has Activity(s)"
                  v-model="booking_activity_filter"
                  :items="activeInventory"
                  :rules="[(v) => !!v || 'Item is required']"
                  required
                  multiple
                  item-text="name"
                  item-value="public_id"
                  class="futuristic-input"
                ></v-select>
              </v-container>
            </v-flex>
            <v-flex lg2 md3 sm4 xs12>
              <v-container>
                <v-autocomplete
                  label="Has Partner Type"
                  v-model="booking_partner_type_filter"
                  :items="$partnerTypes()"
                  :rules="[(v) => !!v || 'Item is required']"
                  required
                  class="futuristic-input"
                ></v-autocomplete>
              </v-container>
            </v-flex>
            <v-flex lg2 md3 sm4 xs12>
              <v-container>
                <v-autocomplete
                  label="Has Partner Name"
                  v-model="booking_partners_filter"
                  :items="$partnerBookings()"
                  :rules="[(v) => !!v || 'Item is required']"
                  required
                  class="futuristic-input"
                ></v-autocomplete>
              </v-container>
            </v-flex>
            <v-flex lg2 md3 sm4 xs12>
              <v-container>
                <v-autocomplete
                  label="Has Membership"
                  v-model="booking_membershiplevel_filter"
                  :items="$memberBookings()"
                  :rules="[(v) => !!v || 'Item is required']"
                  required
                  class="futuristic-input"
                ></v-autocomplete>
              </v-container>
            </v-flex>
            <v-flex lg2 md3 sm4 xs12>
              <v-container>
                <v-autocomplete
                  label="Payment Status"
                  v-model="payment_status_filter"
                  :items="$findPaymentStatus()"
                  :rules="[(v) => !!v || 'Item is required']"
                  required
                  class="futuristic-input"
                ></v-autocomplete>
              </v-container>
            </v-flex>
          </v-layout>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-card flat class="futuristic-card">
      <v-card-title class="card-header">
        <h4 class="earth-color">UPCOMING BOOKINGS</h4>
        <h4 v-if="route === 'SearchResults'" class="earth-color">
          BOOKINGS SEARCH RESULTS
        </h4>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          text="Search"
          single-line
          hide-details
          v-model="search"
          class="futuristic-search"
        ></v-text-field>
      </v-card-title>

      <v-data-table
        :headers="all_columns"
        :items="$filterBookingsReport"
        :search="search"
        :rows-per-page-items="[10, 25, { text: 'All', value: -1 }]"
        :disable-initial-sort="true"
        :loading="$loadingTrue"
        no-data-text
        :scroll="getMore"
        class="futuristic-table"
      >
        <v-progress-linear slot="progress" color="#587e27" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="props">
          <td class="futuristic-table-cell">{{ formated_date_time(props.item.created_at) }}</td>

          <td class="futuristic-table-cell" style="text-transform: capitalize">
            <router-link
              :to="{
                name: 'Booking',
                params: { booking_id: props.item.booking_public_id },
              }"
            >
              <a class="text-dark">
                <u>{{ props.item.booking_ref_code }}</u>
              </a>
            </router-link>
          </td>
          <td class="futuristic-table-cell" style="text-transform: uppercase">
            {{ props.item.booking_done_by }}
          </td>
          <td class="futuristic-table-cell">{{ props.item.booking_type }}</td>
          <!-- Added Destination display -->
          <td class="futuristic-table-cell">{{ props.item.destination }}</td>
          <!-- Added Country display -->
          <td class="futuristic-table-cell">{{ props.item.country }}</td>
          <td class="futuristic-table-cell">
            {{ formated_date(props.item.booking_check_in_date) }}
          </td>
          <td class="futuristic-table-cell">
            {{ formated_date(props.item.booking_check_out_date) }}
          </td>
          <td class="futuristic-table-cell">{{ props.item.guest_total }}</td>
          <td class="futuristic-table-cell">
            {{ props.item.booking_currency }}
            {{ $roundOff(props.item.booking_total) }}
            <br v-if="props.item.credit_note_issued" />
            <v-icon
              style="font-size: 140%"
              color="#587e27"
              v-if="props.item.credit_note_issued"
              >credit_card</v-icon
            >
            <span v-if="props.item.credit_note_issued">Credit Note Issued</span>
          </td>
          <td class="futuristic-table-cell" v-bind:style="props.item.booking_color">
            {{ props.item.booking_status }}
          </td>
          <td class="futuristic-table-cell">{{ props.item.session_user }}</td>
          <td class="futuristic-table-cell">
            <v-btn
              :depressed="true"
              small
              @click="openBooking(props.item.booking_public_id)"
              class="futuristic-btn"
              >View Booking</v-btn
            >
          </td>
        </template>

        <v-alert slot="no-results" :value="true" color="error" icon="warning"
          >Your search for "{{ search }}" found no results.</v-alert
        >
      </v-data-table>
      <div class="text-xs-center" v-if="$filterBookingsReport.length <= 0">
        <ball-clip-rotate-pulse-loader
          color="#587e27"
          size="50px"
        ></ball-clip-rotate-pulse-loader>
      </div>

      <v-container class="button-container">
        <v-btn
          :depressed="true"
          @click="generateCustomCsv()"
          color="#587e27"
          :loading="this.$store.state.LoadingStore.loading"
          class="futuristic-btn"
          >Generate Report</v-btn
        >
        <v-btn
          :depressed="true"
          @click="getMore()"
          color="#2196f3"
          :loading="this.$store.state.LoadingStore.loading"
          class="futuristic-btn"
          >GET MORE</v-btn
        >

        <vue-json-excel
          type="xls"
          worksheet="Bookings Data"
          :name="
            this.$moment().format('DD-MM-YYYY HH:mm:ss') +
            ' Filtered Report (Beta).xls'
          "
          :data="$filterBookingsReport"
          :fields="reportFields"
        >
          <v-btn color="#f44336" :depressed="true" class="futuristic-btn"
            >GENERATE REPORT (EXCEL BETA)</v-btn
          >
        </vue-json-excel>
        <vue-json-excel
          type="csv"
          worksheet="Bookings Data"
          :name="
            this.$moment().format('DD-MM-YYYY HH:mm:ss') +
            ' Filtered Report (Beta).csv'
          "
          :data="$filterBookingsReport"
          :fields="reportFields"
        >
          <v-btn color="#ff9800" :depressed="true" class="futuristic-btn"
            >GENERATE REPORT (CSV BETA)</v-btn
          >
        </vue-json-excel>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import SearchTabs from "../Bookings/FindBooking";
import VueJsonToCsv from "vue-json-to-csv";
import VueJsonExcel from "vue-json-excel";
export default {
  components: { SearchTabs, VueJsonExcel },
  name: "Bookings",
  data() {
    return {
      localData: JSON.parse(localStorage.getItem("unem")),
      search: "",
      destination_filter: null, // Added destination filter
      country_filter: null, // Added country filter

      route: this.$route.name,
      AllStreamedBookings: null,
      bookingsTableData: [],
      token: "M2JlMTFiZDUtYWU0OS00NTkzLWI1MjMtZDBlOWVmZmFmZGUz",
      isConnected: false,
      page: 2,
      bookingReportTitle:
        this.$moment().format("DD-MM-YYYY HH:mm:ss a") +
        " Filtered Report (Beta)",
      reportFields: {
        Created_At: {
          field: "created_at",
          callback: (date) => {
            return this.report_date_format(date);
          },
        },
        Check_In_Date: {
          field: "booking_check_in_date",
          callback: (date) => {
            return this.report_date_format(date);
          },
        },
        Check_Out_Date: {
          field: "booking_check_in_date",
          callback: (date) => {
            return this.report_date_format(date);
          },
        },
        Booking_Ref: "booking_ref_code",
        Booking_Type: "booking_type",
        // Added Destination to report
        Destination: "destination",
        // Added Country to report
        Country: "country",
        Ticket: "booking_ticket",
        Client_Name: "booking_done_by",
        Email: "email_address",
        Phone_Number: "phone_number",
        Number_of_Guests: "guest_total",
        Vehicle_Fees: "vehicle_total",
        Entry_Pax: {
          field: "guests",
          callback: (guests) => {
            let guestList = "";
            let i = 0;
            while (i < guests.length) {
              if (guests[i]["no_of_guests"] > 0) {
                guestList = guestList + guests[i]["guest_type"] + " (V), ";
              }
              i++;
            }
            return guestList;
          },
        },
        Vehicles: {
          field: "vehicles",
          callback: (vehicles) => {
            let vehicleList = "";
            let i = 0;
            while (i < vehicles.length) {
              if (vehicles[i]["vehicles"] > 0) {
                vehicleList =
                  vehicleList +
                  vehicles[i]["vehicle_charge_category"] +
                  " (V), ";
              }
              i++;
            }
            return vehicleList;
          },
        },
        Activities: {
          field: "activities",
          callback: (activities) => {
            let activityList = "";
            let i = 0;
            while (i < activities.length) {
              activityList =
                activityList + activities[i]["inventory_name"] + ", ";
              i++;
            }
            return activityList;
          },
        },
        "Accommodation/Camping": {
          field: "accommodations",
          callback: (accommodations) => {
            let accommodationList = "";
            let i = 0;
            while (i < accommodations.length) {
              accommodationList =
                accommodationList + accommodations[i]["facility_name"] + ", ";
              i++;
            }
            return accommodationList;
          },
        },
        Status: "booking_status",
        Source: "session_user",
        Gatepass_Source: "gatepass_source",
        Payment_Status: "booking_payment_status",
        Currency: "booking_currency",
        Booking_Total: "booking_total",
        Booking_VAT: "vat",
        Booking_Catering_levy: "catering_levy",
        Booking_Net: "after_tax",
      },
      all_columns: [
        {
          text: "Created on",
          value: "created_at",
        },
        {
          text: "Ref",
          value: "booking_ref_code",
        },
        {
          text: "Client Name",
          value: "booking_done_by",
        },
        {
          text: "Booking Type",
          value: "booking_type",
        },
        // Added Destination column
        {
          text: "Destination",
          value: "destination",
        },
        // Added Country column
        {
          text: "Country",
          value: "country",
        },
        {
          text: "Check In",
          value: "check_in",
        },
        {
          text: "Check Out",
          value: "check_out",
        },
        {
          text: "Entry Pax",
          value: "guest_total",
        },
        {
          text: "Booking Total",
          value: "booking_total",
        },
        {
          text: "Booking Status",
          value: "booking_status",
        },
        {
          text: "Source",
          value: "session_user",
        },
        {
          text: "Action",
          value: "",
        },
      ],
      columns: [
        {
          text: "Created on",
          value: "created_at",
        },
        {
          text: "Ref",
          value: "booking_ref_code",
        },
        {
          text: "Client Name",
          value: "booking_done_by",
        },
        {
          text: "Booking Type",
          value: "booking_type",
        },
        // Added Destination column
        {
          text: "Destination",
          value: "destination",
        },
        // Added Country column
        {
          text: "Country",
          value: "country",
        },
        {
          text: "Check In",
          value: "check_in",
        },
        {
          text: "Check Out",
          value: "check_out",
        },
        {
          text: "Number of Guests",
          value: "guest_total",
        },
        {
          text: "Status",
          value: "booking_status",
        },
        {
          text: "In-House Status",
          value: "in_house_status",
        },
        {
          text: "Source",
          value: "session_user",
        },
        {
          text: "Action",
          value: "",
        },
      ],
    };
  },
  // beforeCreate() {
  //   this.$store.state.BookingStore.all_bookings = [];

  //     this.$store.dispatch("get_all_streamed_bookings_report");

  // },

  created() {
    this.localData.user_type_id == "230862f9";
    this.$store.dispatch("get_all_destinations");
    this.$store.dispatch("get_all_countries");
    this.$store.dispatch("get_all_streamed_bookings_report");
  },

  updated() {
    this.route = this.$route.name;
  },
  computed: {
    newData() {
      var bookings = [];
      this.allBookings.map(function (booking) {
        bookings.push(booking);
      });
      return bookings;
    },

    newList() {
      return {
        minCols: 26,
        minRows: 500,
        rowHeaders: true,
        columnSorting: true,
        filters: true,
        dropdownMenu: true,
        contextMenu: true,
        autoRowSize: true,
        manualColumnMove: true,
        manualRowMove: true,
        fillHandle: {
          autoInsertRow: false,
        },
        data: this.newData,
        colHeaders: [
          "Created on",
          "Ref",
          "Client Name",
          "Booking Type",
          "Destination", // Added Destination
          "Country",     // Added Country
          "Check In",
          "Check Out",
          "Number of Guests",
          "Status",
        ],
        columns: [
          {
            data: "created_at",
            type: "date",
            dateFormat: "MM/DD/YYYY",
          },
          {
            type: "text",
            data: "booking_ref_code",
          },
          {
            type: "text",
            data: "booking_done_by",
          },
          {
            data: "booking_type",
            type: "text",
          },
          // Added Destination column
          {
            data: "destination",
            type: "text",
          },
          // Added Country column
          {
            data: "country",
            type: "text",
          },
          {
            type: "date",
            dateFormat: "MM/DD/YYYY",
            data: "booking_check_in_date",
          },
          {
            type: "date",
            dateFormat: "MM/DD/YYYY",
            data: "booking_check_out_date",
          },
          {
            data: "guest_total",
            type: "numeric",
            numericFormat: {
              pattern: "0",
            },
          },
          {
            type: "text",
            data: "booking_status",
          },
        ],
      };
    },
    spinnerStyle() {
      return {
        height: this.size,
        width: this.size,
        border: parseFloat(this.size) / 10 + "px solid" + this.color,
        opacity: 0.4,
        borderRadius: this.radius,
      };
    },
    spinnerBasicStyle() {
      return {
        height: this.size,
        width: this.size,
        position: "relative",
      };
    },
  },
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
      default: "#5dc596",
    },
    size: {
      type: String,
      default: "60px",
    },
    margin: {
      type: String,
      default: "2px",
    },
    radius: {
      type: String,
      default: "100%",
    },
  },
  methods: {
    getMore() {
      this.loading = true;
      if (this.page === 2) {
        this.$store.dispatch("get_all_streamed_bookings_report", this.page);
        this.page = this.page + 1;
      } else {
        this.$store.dispatch("get_all_streamed_bookings_report", this.page);
        this.page = this.page + 1;
      }
    },
    generateCustomCsv() {
      var idList = [];
      this.$filterBookingsReport.map(function (booking) {
        idList.push(booking.booking_public_id);
      });
      var data = {
        booking_ids: idList,
        session_id: localStorage.getItem("lkjhgfdsa"),
      };
      this.$store.dispatch("generate_custom_csv", data);
    },
    
   
    openBooking: function (publicId) {
      this.$router.push({
        name: "Booking",
        params: {
          booking_id: publicId,
        },
      });
    },
  },
};
</script>

<style scoped>
/* Futuristic Card */
.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  margin-top: 16px;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.futuristic-inner-card {
  padding: 16px;
  border-radius: 8px;
  background: #f8f9fa;
  margin: 8px;
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px 8px 0 0;
  display: flex;
  flex-direction: column;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
}

.futuristic-expansion {
  border-radius: 8px;
  overflow: hidden;
}

.futuristic-expansion >>> .v-expansion-panel__header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  font-weight: 600;
}

.futuristic-input >>> .v-input__control,
.futuristic-input >>> .v-text-field__slot,
.futuristic-input >>> .v-select__slot {
  background: #ffffff;
  border-radius: 6px;
  padding: 0 8px;
}

.futuristic-input >>> .v-label {
  color: #587e27;
  font-weight: 500;
}

.futuristic-search >>> .v-input__control {
  background: #ffffff;
  border-radius: 24px;
  padding: 0 8px;
}

.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
  margin: 4px;
  color: white;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.futuristic-table {
  width: 100%;
  border-collapse: collapse;
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.futuristic-table >>> th,
.futuristic-table >>> td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
}

.futuristic-table >>> th {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  color: #587e27;
  font-weight: 600;
}

.futuristic-table >>> tr:hover {
  background: #f5f7fa;
}

.futuristic-table-cell {
  padding: 12px;
  border-bottom: 1px solid #e0e0e0;
}

.button-container {
  padding: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .futuristic-card {
    padding: 12px;
  }

  .card-header {
    padding: 12px;
  }

  .futuristic-inner-card {
    padding: 12px;
    margin: 6px;
  }

  .futuristic-table >>> th,
  .futuristic-table >>> td {
    padding: 8px;
  }
  
  .button-container {
    flex-direction: column;
    align-items: stretch;
  }
  
  .futuristic-btn {
    margin: 4px 0;
  }
}

@media (max-width: 600px) {
  .futuristic-card {
    padding: 8px;
    border-radius: 6px;
  }

  .card-header {
    padding: 8px;
  }

  .futuristic-inner-card {
    padding: 8px;
    margin: 4px;
  }

  .futuristic-table >>> th,
  .futuristic-table >>> td {
    padding: 6px;
    font-size: 0.85rem;
  }
  
  .futuristic-btn {
    font-size: 0.8rem;
    padding: 0 12px;
    height: 36px;
  }
}
</style>